var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _rect3, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 16,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 16,
    rx: 2,
    fill: "#00579F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98289 10.722H8.66357L9.48877 5.61963H10.808L9.98289 10.722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7647 5.74408C14.5045 5.64085 14.0918 5.52686 13.5814 5.52686C12.2785 5.52686 11.3611 6.22161 11.3554 7.21491C11.3446 7.94776 12.0123 8.3548 12.5117 8.59916C13.0221 8.84886 13.1956 9.01183 13.1956 9.2344C13.1904 9.57622 12.7832 9.73379 12.4033 9.73379C11.8766 9.73379 11.5944 9.65255 11.1655 9.46238L10.9917 9.38085L10.8071 10.5262C11.1166 10.6672 11.6867 10.7923 12.2785 10.7978C13.6629 10.7978 14.5641 10.1138 14.5748 9.05526C14.58 8.47442 14.2275 8.02936 13.4673 7.66567C13.0059 7.43221 12.7233 7.27479 12.7233 7.03592C12.7287 6.81876 12.9623 6.59634 13.4832 6.59634C13.9121 6.58544 14.2272 6.68854 14.466 6.79171L14.5853 6.84589L14.7647 5.74408Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5192 8.91443C16.6279 8.6213 17.046 7.48682 17.046 7.48682C17.0405 7.49771 17.1544 7.18828 17.2195 6.99832L17.3117 7.43798C17.3117 7.43798 17.5616 8.65932 17.6158 8.91443C17.4096 8.91443 16.7798 8.91443 16.5192 8.91443ZM18.1478 5.61963H17.1273C16.8126 5.61963 16.5735 5.71183 16.4377 6.04298L14.478 10.722H15.8623C15.8623 10.722 16.0903 10.0922 16.1392 9.95657C16.2911 9.95657 17.6378 9.95657 17.8331 9.95657C17.871 10.1357 17.9906 10.722 17.9906 10.722H19.2121L18.1478 5.61963Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56148 5.61963L6.26944 9.09898L6.12825 8.39332C5.88937 7.57909 5.14022 6.69445 4.3042 6.25458L5.48767 10.7166H6.88281L8.95656 5.61963H7.56148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06967 5.61963H2.94701L2.92529 5.72272C4.5811 6.14614 5.67771 7.16678 6.12825 8.39354L5.66681 6.04853C5.59084 5.72265 5.35738 5.63038 5.06967 5.61963Z",
    fill: "#FAA61A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3335,
    width: 23.3333,
    height: 16,
    rx: 2,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.167 11.4381C38.3726 12.1236 37.3422 12.5375 36.2162 12.5375C33.7037 12.5375 31.667 10.4771 31.667 7.93549C31.667 5.39388 33.7037 3.3335 36.2162 3.3335C37.3422 3.3335 38.3726 3.74733 39.167 4.43285C39.9614 3.74733 40.9918 3.3335 42.1178 3.3335C44.6303 3.3335 46.667 5.39388 46.667 7.93549C46.667 10.4771 44.6303 12.5375 42.1178 12.5375C40.9918 12.5375 39.9614 12.1236 39.167 11.4381Z",
    fill: "#ED0006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.167 11.4381C40.1451 10.594 40.7654 9.33803 40.7654 7.93549C40.7654 6.53294 40.1451 5.27694 39.167 4.43285C39.9614 3.74733 40.9918 3.3335 42.1178 3.3335C44.6303 3.3335 46.667 5.39388 46.667 7.93549C46.667 10.4771 44.6303 12.5375 42.1178 12.5375C40.9918 12.5375 39.9614 12.1236 39.167 11.4381Z",
    fill: "#F9A000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1672 4.43311C40.1453 5.2772 40.7655 6.53319 40.7655 7.93573C40.7655 9.33826 40.1453 10.5943 39.1672 11.4383C38.1891 10.5943 37.5688 9.33826 37.5688 7.93573C37.5688 6.53319 38.1891 5.2772 39.1672 4.43311Z",
    fill: "#FF5E00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6665,
    width: 23.3333,
    height: 16,
    rx: 2,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0632 8.08441C68.0632 10.626 66.0265 12.6864 63.514 12.6864C61.0016 12.6864 58.9648 10.626 58.9648 8.08441C58.9648 5.5428 61.0016 3.48242 63.514 3.48242C66.0265 3.48242 68.0632 5.5428 68.0632 8.08441Z",
    fill: "#ED0006"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9651 8.08441C73.9651 10.626 71.9283 12.6864 69.4159 12.6864C66.9034 12.6864 64.8667 10.626 64.8667 8.08441C64.8667 5.5428 66.9034 3.48242 69.4159 3.48242C71.9283 3.48242 73.9651 5.5428 73.9651 8.08441Z",
    fill: "#0099DF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.465 4.58203C67.4432 5.42612 68.0634 6.68212 68.0634 8.08465C68.0634 9.48719 67.4432 10.7432 66.465 11.5873C65.4869 10.7432 64.8667 9.48719 64.8667 8.08465C64.8667 6.68212 65.4869 5.42612 66.465 4.58203Z",
    fill: "#6C6BBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/Cards.379acbacedd52ce090ae832a11c298d5.svg";
export { ForwardRef as ReactComponent };